<template>
  <div>
    <commBanner :obj="obj"></commBanner>
    <breadCrum :breadCrumList="breadCrumList"></breadCrum>
    <div class="industry_information_content warp">
      <div class="info_detail">
        <h2>{{ newsInfo.title }}</h2>
        <div class="info_detail_tips">
          <div class="info_detail_date">
            <span v-if="newsInfo.releaseDate">{{ newsInfo.releaseDate.substring(0, 10) }}</span>
            <span>来源：{{ newsInfo.source }}</span>
            <span>阅读量：{{ newsInfo.readCount }}</span>
          </div>
          <user-operation
            v-if="newsInfo.title"
            ref="userOperation"
            class="user_operation"
            v-on:onCollection="onCollection"
            @callCollection="callCancelcollection()"
            :notStatus="active"
            :shareObj="newsInfo"
          ></user-operation>
        </div>
        <div class="info_detail_line"></div>
        <div class="info_detail_desc" v-html="newsInfo.content"></div>
        <div class="info_detail_next" @click="tonextdetail(nextid)">
          下一篇：{{ nexttitle }}
        </div>
        <div class="info_detail_line"></div>
        <comment :id="newsInfo.id"></comment>
      </div>

      <div class="industry_information_recommender">
        <newsRecommend
          :newsRecommendObj="newsRecommendObj"
          @dataRefresh="getRandomList(4)"
          urlType="technology_detail"
        ></newsRecommend>
        <div class="find_right" v-if="advList.length > 0">
          <a :href="'//' + advList[0].url" target="_blank">
            <img :src="advList[0].image" alt="" />
            <span>广告</span>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getRandomArray } from "@/utils/index";
import { addCollection, iscollection, cancelcollection } from "@/api/coment";
import { getDictList, getTechnologyList, getAdv } from "@/api/information";
import { getTechnologyListById } from "@/api/information";
import { getToken } from "@/utils/auth";
import commBanner from "../../common/commBanner";
import newsRecommend from "../../common/newsRecommend";
import userOperation from "../../common/userOperation";
import comment from "../../common/comment";
import breadCrum from "../../common/breadCrum";
export default {
  inject: ["reload"], //注入App里的reload方法
  components: {
    commBanner,
    newsRecommend,
    userOperation,
    comment,
    breadCrum,
  },
  data() {
    return {
      active: false,
      obj: {
        title: "环保技术",
        roleType: "",
        personalType: 2,
      },
      breadCrumList: [
        { name: "环保技术", url: "/technology" },
        { name: "环保详情", url: "" },
      ],
      newsRecommendObj: {
        title: "推荐资讯",
        text: "换一批",
        isImg: true,
        newData: [],
      },
      flag: false,
      newsInfo: {},
      allList: [],
      advType: 4,
      advList: [],
      nextid: null,
      nexttitle: "",
    };
  },
  created() {
    this.getTechnologyListById();
    this.getRecommendTechnologyList();
    this.getAdv();
    if (getToken() != undefined) {
      this.getIscollection();
    }
    if (this.$store.state.user.userInfo != null) {
      let type = this.$store.state.user.userInfo.type;
      this.obj.roleType = type;
    }
  },
  watch: {
    $route: {
      handler: function (route) {
        // this.getTechnologyListById();
      },
      immediate: true,
    },
  },
  methods: {
    //获取广告
    getAdv() {
      getAdv({
        curPage: 1,
        limit: 10,
        type: this.advType,
      }).then((res) => {
        this.advList = res.page.list;
      });
    },
    tonextdetail(id) {
      if ("null" != id && null != id && id > 0) {
        // window.location.href='technology_detail?id='+id;
        this.reload();
        this.$router.push({
          path: "/technology_detail",
          query: { id: id },
        });
      } else {
        this.$message({
          message: "没有更多了",
          duration: 1000,
        });
      }
    },
    //获取推荐技术内容 前端随机取4个
    getRecommendTechnologyList() {
      getTechnologyList({
        recommend: 1,
      }).then((res) => {
        if(res.code == 0){
          this.allList = res.page.list;
          this.getRandomList(4);
        }
      });
    },
    getRandomList(length) {
      this.newsRecommendObj.newData = _.compact(
        getRandomArray(_.cloneDeep(this.allList), length)
      );
    },
    //查看收藏状态
    getIscollection() {
      let params = {
        goodsid: this.$route.query.id,
        goodstype: 3,
      };
      iscollection(params)
        .then((res) => {
          if (res.code == 0) {
            if (true == res.data) {
              this.active = true;
            }
          }
        })
        .catch((err) => {});
    },
    //收藏
    onCollection() {
      this.active = true;
      let params = {
        goodsId: this.$route.query.id,
        goodsType: 3,
      };
      addCollection(params)
        .then((res) => {
          if (res.code == 0) {
            this.$message({
              message: "收藏成功！",
              type: "success",
              duration: 1000,
            });
          }
        })
        .catch((err) => {});
    },
    //取消收藏
    callCancelcollection() {
      let params = {
        goodsid: this.$route.query.id,
        goodstype: "3",
      };
      cancelcollection(params)
        .then((res) => {
          if (res.code == 0) {
            this.$message({
              type: "success",
              message: "取消收藏",
            });
          }
        })
        .catch((err) => {});
    },
    //获取资讯详情
    getTechnologyListById() {
      getTechnologyListById({ id: this.$route.query.id })
        .then((res) => {
          if(res.code == 0){
            this.flag = true;
            this.newsInfo = res.data;
            this.getMate(res.data);
            this.newsInfo.content = this.newsInfo.content.replace(
              /<img/g,
              "<img style='width:100%;height:auto;'"
            );
            this.nextid = res.next.id;
            this.nexttitle = res.next.title;
          }
        })
        .catch((err) => {});
    },
    keepTextStyle(val) {
      return (val + "").replace(/(<br[^>]*>|\s*)/g, "");
    },
    getMate(data) {
      var metas = document.getElementsByTagName("meta");
      metas[0].name = "keyword";
      metas[0].content = data.seokeywords;
      metas[1].name = "description";
      metas[1].content = data.seodescription;
      document.getElementsByTagName("title")[0].innerText =
        data.title + "_智污邦环保服务平台";
    },
  },
};
</script>

<style scoped lang="less">
/deep/.info_detail_desc {
  font-size: 14px;
  font-weight: 400;
  color: #666666;
}
.industry_information_content {
  display: flex;

  .info_detail {
    width: 70%;
    margin-right: 30px;
    h2 {
      font-size: 24px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #333333;
    }
    .info_detail_tips {
      display: flex;
      align-items: center;
      justify-content: space-between;
      .info_detail_date {
        flex: 6;
        margin-top: 20px;
        span {
          font-size: 14px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #999999;
          margin-right: 20px;
          &:last-of-type {
            margin-right: 0;
          }
        }
      }
      .user_operation {
        flex: 4;
      }
    }
    .info_detail_line {
      width: 100%;
      height: 1px;
      margin: 10px 0;
      background: #eeeeee;
    }
    .info_detail_desc {
      p {
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #666666;
        line-height: 2;
        text-indent: 2em;
        img {
          width: 100%;
          height: 364px;
        }
      }
    }
    .info_detail_next {
      cursor: pointer;
      font-size: 14px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #333333;
      margin: 35px 0;
      &:hover {
        color: blue;
      }
    }
  }

  .industry_information_recommender {
    width: 30%;
  }
  .find_right {
    width: 100%;
    position: relative;
    span {
      position: absolute;
      top: 5px;
      left: 5px;
      font-size: 14px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #ffffff;
    }
    img {
      width: 100%;
      height: 184px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/view/technology/technology_detail.vue